import { render, staticRenderFns } from "./MarsApp.vue?vue&type=template&id=6cf4fc6a&scoped=true&"
import script from "./MarsApp.vue?vue&type=script&lang=js&"
export * from "./MarsApp.vue?vue&type=script&lang=js&"
import style0 from "./MarsApp.vue?vue&type=style&index=0&id=6cf4fc6a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf4fc6a",
  null
  
)

export default component.exports